module.exports = __webpack_public_path__ + "img/35-Starting to thin.7c2f9117.png";